import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWillsAndTrustsPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-wills-and-trusts/']} />;
}
